// extracted by mini-css-extract-plugin
export default {"root":"Autorun_root__9rjWF","header":"Autorun_header__RPboO","left_block":"Autorun_left_block__fqF9c","title_block":"Autorun_title_block__1+6Ky","subtitle":"Autorun_subtitle__oHOdI"};